import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_TEMPLATES = false

/*
 * Template Actions
 * 
 */

export function fetchTemplatesList(dispatch) {
    let cmd = 'FETCH_TEMPLATES_LIST'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productTemplateId: 1,
                            name: 'Bally Countertops',
                            published: 1,
                            filter: "[Manufacturer]=BAL AND [ManufacturerLineCode] In (MA, RO)",
                            websiteCategory1: "Cabinetry-Door-Styles 3",
                            websiteCategory2: "Cabinetry-Door-Styles 4",
                            priority: 1,
                            productSeriesId: 1,
                            groupMetaClassName: "BaseProductContent",
                            metaClassName: "BaseVariationContent",
                            groupPageLayoutDefault: "GroupPageLayoutDefault",
                            createdBy: "AnonymousUser",
                            lastUpdatedAt: "2018-08-14T21:01:49.728",
                            productTemplateLanguages: [
                                {
                                    language: "en",

                                    groupCode: "Group",
                                    groupName: "Grousssaaccccas",
                                    groupDescription: "Test Des",
                                    groupURL: "localhost",
                                    groupSEDescription: "Test",
                                    groupSETitle: "Test SE",
                                    groupSEKeywords: "Test Key",
                                    groupActive: "F",
                                    groupStartDate: "2018-07-31T15:10:26",
                                    groupEndDate: "2018-07-31T15:10:26",
                                    groupMappedToReicoSite: "T",
                                    groupMappedToDistributorSite: "F",
                                    code: "#Lamination#.Length#.#Depth#.#Thickness#",
                                    name: "Test Name",
                                    description: "Description",
                                    active: "Y",
                                    startDate: "2018-07-31T15:10:26",
                                    endDate: "2018-07-31T15:10:26",
                                    manufacturerPartNumber: "[BRPART]",
                                    gtin: "[BRUPC]",
                                    imageOverride: "Image Override",
                                    overrideImageBaseName: "Override Image Base Name",
                                    swatchImageName: "Swatch Image Name",
                                    colorSwatch: "Color Swatch",
                                    trait1Name: "Trait 1 Name",
                                    trait1Value: "Trait 1 Value",
                                    trait2Name: "Trait 2 Name",
                                    trait2Value: "Trait 2 Valueas",
                                    minimumQty: "0",
                                    maximumQty: "10",
                                    inStockQuantity: "7",
                                    weight: "90",
                                    showQuoteButton: "F",
                                    showBuyButton: "T",
                                    hidePriceUntilCart: "T",
                                    regularPrice: "24.55",
                                    salePrice: "25.33",
                                    msrpPrice: "26.22",
                                    mapPrice: "30.11"
                                }
                            ]
                        },
                        {
                            productTemplateId: 2,
                            name: 'Bally Backsplashes',
                            published: 0,
                            filter: "[Manufacturer]=BAL AND [ManufacturerLineCode] In (MA, RO)",
                            websiteCategory1: "Cabinetry-Door-Styles 3",
                            websiteCategory2: "Cabinetry-Door-Styles 4",
                            priority: 1,
                            productSeriesId: 2,
                            groupMetaClassName: "BaseProductContent",
                            metaClassName: "BaseVariationContent",
                            groupPageLayoutDefault: "GroupPageLayoutDefault",
                            createdBy: "AnonymousUser",
                            lastUpdatedAt: "2018-08-14T21:01:49.728",
                            productTemplateLanguages: [
                                {
                                    language: "en",

                                    groupCode: "Group",
                                    groupName: "Grousssaaccccas",
                                    groupDescription: "Test Des",
                                    groupURL: "localhost",
                                    groupSEDescription: "Test",
                                    groupSETitle: "Test SE",
                                    groupSEKeywords: "Test Key",
                                    groupActive: "F",
                                    groupStartDate: "2018-07-31T15:10:26",
                                    groupEndDate: "2018-07-31T15:10:26",
                                    groupMappedToReicoSite: "T",
                                    groupMappedToDistributorSite: "F",
                                    code: "#Lamination#.Length#.#Depth#.#Thickness#",
                                    name: "Test Name",
                                    description: "Description",
                                    active: "Y",
                                    startDate: "2018-07-31T15:10:26",
                                    endDate: "2018-07-31T15:10:26",
                                    manufacturerPartNumber: "[BRPART]",
                                    gtin: "[BRUPC]",
                                    imageOverride: "Image Override",
                                    overrideImageBaseName: "Override Image Base Name",
                                    swatchImageName: "Swatch Image Name",
                                    colorSwatch: "Color Swatch",
                                    trait1Name: "Trait 1 Name",
                                    trait1Value: "Trait 1 Value",
                                    trait2Name: "Trait 2 Name",
                                    trait2Value: "Trait 2 Valueas",
                                    minimumQty: "0",
                                    maximumQty: "10",
                                    inStockQuantity: "7",
                                    weight: "90",
                                    showQuoteButton: "F",
                                    showBuyButton: "T",
                                    hidePriceUntilCart: "T",
                                    regularPrice: "24.55",
                                    salePrice: "25.33",
                                    msrpPrice: "26.22",
                                    mapPrice: "30.11"
                                }
                            ]
                        },
                        {
                            productTemplateId: 3,
                            name: 'Merillat Classic Door Styles',
                            published: 1,
                            filter: "[Manufacturer]=BAL AND [ManufacturerLineCode] In (MA, RO)",
                            websiteCategory1: "Cabinetry-Door-Styles 3",
                            websiteCategory2: "Cabinetry-Door-Styles 4",
                            priority: 1,
                            productSeriesId: 3,
                            groupMetaClassName: "BaseProductContent",
                            metaClassName: "BaseVariationContent",
                            groupPageLayoutDefault: "GroupPageLayoutDefault",
                            createdBy: "AnonymousUser",
                            lastUpdatedAt: "2018-08-14T21:01:49.728",
                            productTemplateLanguages: [
                                {
                                    language: "en",

                                    groupCode: "Group",
                                    groupName: "Grousssaaccccas",
                                    groupDescription: "Test Des",
                                    groupURL: "localhost",
                                    groupSEDescription: "Test",
                                    groupSETitle: "Test SE",
                                    groupSEKeywords: "Test Key",
                                    groupActive: "F",
                                    groupStartDate: "2018-07-31T15:10:26",
                                    groupEndDate: "2018-07-31T15:10:26",
                                    groupMappedToReicoSite: "T",
                                    groupMappedToDistributorSite: "F",
                                    code: "#Lamination#.Length#.#Depth#.#Thickness#",
                                    name: "Test Name",
                                    description: "Description",
                                    active: "Y",
                                    startDate: "2018-07-31T15:10:26",
                                    endDate: "2018-07-31T15:10:26",
                                    manufacturerPartNumber: "[BRPART]",
                                    gtin: "[BRUPC]",
                                    imageOverride: "Image Override",
                                    overrideImageBaseName: "Override Image Base Name",
                                    swatchImageName: "Swatch Image Name",
                                    colorSwatch: "Color Swatch",
                                    trait1Name: "Trait 1 Name",
                                    trait1Value: "Trait 1 Value",
                                    trait2Name: "Trait 2 Name",
                                    trait2Value: "Trait 2 Valueas",
                                    minimumQty: "0",
                                    maximumQty: "10",
                                    inStockQuantity: "7",
                                    weight: "90",
                                    showQuoteButton: "F",
                                    showBuyButton: "T",
                                    hidePriceUntilCart: "T",
                                    regularPrice: "24.55",
                                    salePrice: "25.33",
                                    msrpPrice: "26.22",
                                    mapPrice: "30.11"
                                }
                            ]
                        },
                        {
                            productTemplateId: 4,
                            name: 'Merillat Basic Door Styles',
                            published: 0,
                            filter: "[Manufacturer]=BAL AND [ManufacturerLineCode] In (MA, RO)",
                            websiteCategory1: "Cabinetry-Door-Styles 3",
                            websiteCategory2: "Cabinetry-Door-Styles 4",
                            priority: 1,
                            productSeriesId: 1,
                            groupMetaClassName: "BaseProductContent",
                            metaClassName: "BaseVariationContent",
                            groupPageLayoutDefault: "GroupPageLayoutDefault",
                            createdBy: "AnonymousUser",
                            lastUpdatedAt: "2018-08-14T21:01:49.728",
                            productTemplateLanguages: [
                                {
                                    language: "en",

                                    groupCode: "Group",
                                    groupName: "Grousssaaccccas",
                                    groupDescription: "Test Des",
                                    groupURL: "localhost",
                                    groupSEDescription: "Test",
                                    groupSETitle: "Test SE",
                                    groupSEKeywords: "Test Key",
                                    groupActive: "F",
                                    groupStartDate: "2018-07-31T15:10:26",
                                    groupEndDate: "2018-07-31T15:10:26",
                                    groupMappedToReicoSite: "T",
                                    groupMappedToDistributorSite: "F",
                                    code: "#Lamination#.Length#.#Depth#.#Thickness#",
                                    name: "Test Name",
                                    description: "Description",
                                    active: "Y",
                                    startDate: "2018-07-31T15:10:26",
                                    endDate: "2018-07-31T15:10:26",
                                    manufacturerPartNumber: "[BRPART]",
                                    gtin: "[BRUPC]",
                                    imageOverride: "Image Override",
                                    overrideImageBaseName: "Override Image Base Name",
                                    swatchImageName: "Swatch Image Name",
                                    colorSwatch: "Color Swatch",
                                    trait1Name: "Trait 1 Name",
                                    trait1Value: "Trait 1 Value",
                                    trait2Name: "Trait 2 Name",
                                    trait2Value: "Trait 2 Valueas",
                                    minimumQty: "0",
                                    maximumQty: "10",
                                    inStockQuantity: "7",
                                    weight: "90",
                                    showQuoteButton: "F",
                                    showBuyButton: "T",
                                    hidePriceUntilCart: "T",
                                    regularPrice: "24.55",
                                    salePrice: "25.33",
                                    msrpPrice: "26.22",
                                    mapPrice: "30.11"
                                }
                            ]
                        },
                        {
                            productTemplateId: 5,
                            name: 'Virginia Marble Vanity Tops',
                            published: 1,
                            filter: "[Manufacturer]=BAL AND [ManufacturerLineCode] In (MA, RO)",
                            websiteCategory1: "Cabinetry-Door-Styles 3",
                            websiteCategory2: "Cabinetry-Door-Styles 4",
                            priority: 1,
                            productSeriesId: 2,
                            groupMetaClassName: "BaseProductContent",
                            metaClassName: "BaseVariationContent",
                            groupPageLayoutDefault: "GroupPageLayoutDefault",
                            createdBy: "AnonymousUser",
                            lastUpdatedAt: "2018-08-14T21:01:49.728",
                            productTemplateLanguages: [
                                {
                                    language: "en",

                                    groupCode: "Group",
                                    groupName: "Grousssaaccccas",
                                    groupDescription: "Test Des",
                                    groupURL: "localhost",
                                    groupSEDescription: "Test",
                                    groupSETitle: "Test SE",
                                    groupSEKeywords: "Test Key",
                                    groupActive: "F",
                                    groupStartDate: "2018-07-31T15:10:26",
                                    groupEndDate: "2018-07-31T15:10:26",
                                    groupMappedToReicoSite: "T",
                                    groupMappedToDistributorSite: "F",
                                    code: "#Lamination#.Length#.#Depth#.#Thickness#",
                                    name: "Test Name",
                                    description: "Description",
                                    active: "Y",
                                    startDate: "2018-07-31T15:10:26",
                                    endDate: "2018-07-31T15:10:26",
                                    manufacturerPartNumber: "[BRPART]",
                                    gtin: "[BRUPC]",
                                    imageOverride: "Image Override",
                                    overrideImageBaseName: "Override Image Base Name",
                                    swatchImageName: "Swatch Image Name",
                                    colorSwatch: "Color Swatch",
                                    trait1Name: "Trait 1 Name",
                                    trait1Value: "Trait 1 Value",
                                    trait2Name: "Trait 2 Name",
                                    trait2Value: "Trait 2 Valueas",
                                    minimumQty: "0",
                                    maximumQty: "10",
                                    inStockQuantity: "7",
                                    weight: "90",
                                    showQuoteButton: "F",
                                    showBuyButton: "T",
                                    hidePriceUntilCart: "T",
                                    regularPrice: "24.55",
                                    salePrice: "25.33",
                                    msrpPrice: "26.22",
                                    mapPrice: "30.11"
                                }
                            ]
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('ProductTemplate'), { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchTemplateError(dispatch) {

    dispatch(
        {
            type: 'FETCH_TEMPLATE_ERROR',
        }
    )
}

export function createTemplate(template) {
    let cmd = 'CREATE_TEMPLATE'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: template
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {

            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('ProductTemplate'), JSON.stringify(template), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchTemplate(id) {
    let cmd = 'FETCH_TEMPLATE'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productTemplateId: id,
                        name: 'Bally Backsplashes',
                        published: id % 2,
                        filter: "[Manufacturer]=BAL AND [ManufacturerLineCode] In (MA, RO)",
                        websiteCategory1: "Cabinetry-Door-Styles 3",
                        websiteCategory2: "Cabinetry-Door-Styles 4",
                        priority: 1,
                        productSeriesId: 1004,
                        groupMetaClassName: "BaseProductContent",
                        metaClassName: "BaseVariationContent",
                        groupPageLayoutDefault: "GroupPageLayoutDefault",
                        createdBy: "AnonymousUser",
                        lastUpdatedAt: "2018-08-14T21:01:49.728",
                        productTemplateLanguages: [
                            {
                                language: "en",

                                groupCode: "Group",
                                groupName: "Grousssaaccccas",
                                groupDescription: "Test Des",
                                groupURL: "localhost",
                                groupSEDescription: "Test",
                                groupSETitle: "Test SE",
                                groupSEKeywords: "Test Key",
                                groupActive: "F",
                                groupStartDate: "2018-07-31T15:10:26",
                                groupEndDate: "2018-07-31T15:10:26",
                                groupMappedToReicoSite: "T",
                                groupMappedToDistributorSite: "F",
                                code: "#Lamination#.Length#.#Depth#.#Thickness#",
                                name: "Test Name",
                                description: "Description",
                                active: "Y",
                                startDate: "2018-07-31T15:10:26",
                                endDate: "2018-07-31T15:10:26",
                                manufacturerPartNumber: "[BRPART]",
                                gtin: "[BRUPC]",
                                imageOverride: "Image Override",
                                overrideImageBaseName: "Override Image Base Name",
                                swatchImageName: "Swatch Image Name",
                                colorSwatch: "Color Swatch",
                                trait1Name: "Trait 1 Name",
                                trait1Value: "Trait 1 Value",
                                trait2Name: "Trait 2 Name",
                                trait2Value: "Trait 2 Valueas",
                                minimumQty: "0",
                                maximumQty: "10",
                                inStockQuantity: "7",
                                weight: "90",
                                showQuoteButton: "F",
                                showBuyButton: "T",
                                hidePriceUntilCart: "T",
                                regularPrice: "24.55",
                                salePrice: "25.33",
                                msrpPrice: "26.22",
                                mapPrice: "30.11"
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('ProductTemplate/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorTemplate(dispatch) {

    dispatch(
        {
            type: 'TEMPLATE_ERROR'
        }
    )
}

export function updateTemplate(id, template) {
    let cmd = 'UPDATE_TEMPLATE'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: template
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('ProductTemplate/') + id, JSON.stringify(template), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function validateFilterSQL(filter, templateId, seriesId, formulas, grpCode, productMasterId) {
    let cmd = 'VALIDATE_SQL'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES) {

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productMasterId: 2,
                        productCount: 49,
                        filterExpression: "[BRMFG]='BAL' AND [BRLIN] in ('MA','RO')"
                    }
                }
            }
        )

        if (templateId)
            applyFormulaAll.bind(this)(
                {
                    productTemplateId: templateId,
                    productMasterId: 2
                }
            )
    }
    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )
//TODO - move groupCode parameter to body once backend is done
            axios.post(buildRequestUrl(grpCode ? 'GetFilterCountAndSample?groupCode=' + grpCode : 'GetFilterCountAndSample'), JSON.stringify(filter), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )

                    if (templateId)
                        applyFormulaAll.bind(this)(
                            {
                                productTemplateId: templateId,
                                productMasterId: resp.data.productMasterId
                            }
                        )
                    else if (formulas.length && resp.data.productMasterId && resp.data.productMasterId !== productMasterId)
                        applyFormulas.bind(this)(
                            {
                                productMasterId: resp.data.productMasterId,
                                productSeriesId: seriesId,
                                templateFormulas: formulas
                            }
                        )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function getProductGroupCount(filterExpression, productSeriesId, groupCodeFormula) {
    let cmd = 'GET_PRODUCT_GROUP_COUNT';

    var request = {
        filterExpression: filterExpression,
        productSeriesId: productSeriesId,
        groupCodeFormula: groupCodeFormula
    };

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        axios.post(buildRequestUrl('GetProductGroupCount'), JSON.stringify(request), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((response) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: response
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    });
}

export function applyFormula(formula) {
    let cmd = 'APPLY_FORMULA'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        formulaName: "formula",
                        formulaExpression: "%brand%.%species%",
                        formulaResult: "Bally.Maple"
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('ProductTemplate/ApplyFormula'), JSON.stringify(formula), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function applyFormulas(formulas) {
    let cmd = 'APPLY_FORMULAS'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.post(buildRequestUrl('ProductTemplate/ApplyFormulas'), JSON.stringify(formulas), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function applyFormulaAll(formulaAll) {
    let cmd = 'APPLY_FORMULA_ALL'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        formulaResultsByLanguage: {
                            en: [
                                {
                                    formulaName: "GroupCode",
                                    formulaExpression: "%brand%.%species%",
                                    formulaResult: "Bally.Maple"
                                },
                                {
                                    formulaName: "GroupName",
                                    formulaExpression: "%brand%",
                                    formulaResult: "Bally"
                                },
                                {
                                    formulaName: "GroupDescription",
                                    formulaExpression: "Sample Description",
                                    formulaResult: "Sample Description"
                                },
                                {
                                    formulaName: "GroupURL",
                                    formulaExpression: "localhost",
                                    formulaResult: "localhost"
                                },
                                {
                                    formulaName: "GroupSETitle",
                                    formulaExpression: "Sample Title",
                                    formulaResult: "Sample Title"
                                },
                                {
                                    formulaName: "GroupSEDescription",
                                    formulaExpression: "Sample Description",
                                    formulaResult: "Sample Description"
                                },
                                {
                                    formulaName: "GroupSEKeywords",
                                    formulaExpression: "Sample Keyword",
                                    formulaResult: "Sample Keyword"
                                },
                                {
                                    formulaName: "GroupActive",
                                    formulaExpression: "@true@",
                                    formulaResult: "True"
                                },
                                {
                                    formulaName: "GroupStartDate",
                                    formulaExpression: "@GetDate@",
                                    formulaResult: "9/1/2018 7:59:28 AM"
                                },
                                {
                                    formulaName: "GroupEndDate",
                                    formulaExpression: "@CONVERTDATE(\"9999-12-31 23:59:59.999\")@",
                                    formulaResult: "12/31/9999 11:59:59 PM"
                                },
                                {
                                    formulaName: "GroupMappedToReicoSite",
                                    formulaExpression: "@true@",
                                    formulaResult: "True"
                                },
                                {
                                    formulaName: "GroupMappedToDistributorSite",
                                    formulaExpression: "@false@",
                                    formulaResult: "False"
                                },
                                {
                                    formulaName: "Code",
                                    formulaExpression: "#Lamination#.Length#.#Depth#.#Thickness#",
                                    formulaResult: "#Lamination#.Length#.#Depth#.#Thickness#"
                                },
                                {
                                    formulaName: "Name",
                                    formulaExpression: "[BRPART]-%species%",
                                    formulaResult: "108SPLASH-Maple"
                                },
                                {
                                    formulaName: "Description",
                                    formulaExpression: "[BRDES1]",
                                    formulaResult: "MAPLE BACKSPLASH 108"
                                },
                                {
                                    formulaName: "Active",
                                    formulaExpression: "[BRPUB]",
                                    formulaResult: "False"
                                },
                                {
                                    formulaName: "StartDate",
                                    formulaExpression: "@CONVERTDATE(\"2018-08-23\")@",
                                    formulaResult: "8/23/2018 12:00:00 AM"
                                },
                                {
                                    formulaName: "EndDate",
                                    formulaExpression: "@CONVERTDATE(\"2099-12-31\")@",
                                    formulaResult: "12/31/2099 12:00:00 AM"
                                },
                                {
                                    formulaName: "ManufacturerPartNumber",
                                    formulaExpression: "[BRUPC]",
                                    formulaResult: "34561084"
                                },
                                {
                                    formulaName: "GTIN",
                                    formulaExpression: "[BRUPC]",
                                    formulaResult: "34561084"
                                },
                                {
                                    formulaName: "ImageOverride",
                                    formulaExpression: "@false@",
                                    formulaResult: "False"
                                },
                                {
                                    formulaName: "OverrideImageBaseName",
                                    formulaExpression: "Override Image Base Name",
                                    formulaResult: "Override Image Base Name"
                                },
                                {
                                    formulaName: "SwatchImageName",
                                    formulaExpression: "Swatch Image Name",
                                    formulaResult: "Swatch Image Name"
                                },
                                {
                                    formulaName: "ColorSwatch",
                                    formulaExpression: "Color Swatch",
                                    formulaResult: "Color Swatch"
                                },
                                {
                                    formulaName: "Trait1Name",
                                    formulaExpression: "Trait 1 Name",
                                    formulaResult: "Trait 1 Name"
                                },
                                {
                                    formulaName: "Trait1Value",
                                    formulaExpression: "Trait 1 Value",
                                    formulaResult: "Trait 1 Value"
                                },
                                {
                                    formulaName: "Trait2Name",
                                    formulaExpression: "Trait 2 Name",
                                    formulaResult: "Trait 2 Name"
                                },
                                {
                                    formulaName: "Trait2Value",
                                    formulaExpression: "Trait 2 Value",
                                    formulaResult: "Trait 2 Value"
                                },
                                {
                                    formulaName: "MinimumQty",
                                    formulaExpression: "0",
                                    formulaResult: "0"
                                },
                                {
                                    formulaName: "MaximumQty",
                                    formulaExpression: "999",
                                    formulaResult: "999"
                                },
                                {
                                    formulaName: "InStockQuantity",
                                    formulaExpression: "73",
                                    formulaResult: "73"
                                },
                                {
                                    formulaName: "Weight",
                                    formulaExpression: "[BRWEIGHT]",
                                    formulaResult: "12"
                                },
                                {
                                    formulaName: "ShowQuoteButton",
                                    formulaExpression: "@true@",
                                    formulaResult: "True"
                                },
                                {
                                    formulaName: "ShowBuyButton",
                                    formulaExpression: "@true@",
                                    formulaResult: "True"
                                },
                                {
                                    formulaName: "HidePriceUntilCart",
                                    formulaExpression: "@false@",
                                    formulaResult: "False"
                                },
                                {
                                    formulaName: "RegularPrice",
                                    formulaExpression: "[BRMSRP]",
                                    formulaResult: "68.19000"
                                },
                                {
                                    formulaName: "SalePrice",
                                    formulaExpression: "[BRCOST]",
                                    formulaResult: "33.18000"
                                },
                                {
                                    formulaName: "MSRPPrice",
                                    formulaExpression: "[BRMSRP]",
                                    formulaResult: "68.19000"
                                },
                                {
                                    formulaName: "MAPPrice",
                                    formulaExpression: "[BRMSRP]",
                                    formulaResult: "68.19000"
                                }
                            ]
                        }
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(
                buildRequestUrl('ProductTemplate/') + formulaAll.productTemplateId + '/ApplyAllFormulas',
                JSON.stringify({ productMasterId: formulaAll.productMasterId }),
                { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchWebCategories(dispatch) {
    let cmd = 'FETCH_WEB_CATEGORIES'

    if (EMULATION_ALL || EMULATION_MODE_TEMPLATES)

        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('ProductTemplate/WebCategories'), { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function exportTemplate(id, formulas) {
    let cmd = 'EXPORT_TEMPLATE'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.post(buildRequestUrl('ExportTemplate/') + id, JSON.stringify(formulas), { responseType: 'blob', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )

                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'TemplateID_'+id+'_Export.xlsx');
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function importTemplate(id, formulas) {
    let cmd = 'IMPORT_TEMPLATE'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.post(buildRequestUrl('ImportTemplate/') + id, JSON.stringify(formulas), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}